import { render, staticRenderFns } from "./ShadowSettings.vue?vue&type=template&id=4cf6c3d1&scoped=true"
import script from "./ShadowSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShadowSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ShadowSettings.vue?vue&type=style&index=0&id=4cf6c3d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf6c3d1",
  null
  
)

export default component.exports